<template>
  <!-- Table Container Card -->
  <b-card>
    <b-row>
      <b-col cols="12">
        <b-form-group :label="$t('common.name')" label-for="Name">
          <b-form-input
            id="Name"
            v-model="permissionForm.name"
            :placeholder="$t('common.name')"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" class="my-2 text-center"
        ><h3>{{ $t("operation.choose-permissions") }}</h3></b-col
      >
      <b-col cols="12">
        <b-form-group
          label=""
          v-slot="{ ariaDescribedby }"
          class="modify_checkbox"
        >
          <b-form-checkbox-group>
            <b-form-checkbox
              v-for="option in permessionNames"
              v-model="permissionForm.permissionIds"
              :key="option.value"
              :value="option.value"
              :aria-describedby="ariaDescribedby"
              name="flavour-3a"
            >
              {{ option.text }}
            </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="12"
        class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
      >
        <b-button variant="primary" @click="addRole()" :disabled="loading" block>
          <b-spinner v-if="loading" small label="Loading..." class="mr-1" />
          <span v-else>{{ $t("common.submit") }}</span>
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BSpinner,
  BFormCheckboxGroup,
  BFormCheckbox,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    vSelect,
    BFormGroup,
    BSpinner,
    BFormCheckboxGroup,
    BFormCheckbox,
  },
  data() {
    return {
      loading: false,
      permessionList: [],
      permessionNames: [],
      permissionForm: {
        name: "",
        permissionIds: [],
      },

      params: {
        form: {},
        path: "",
      },
    };
  },
  mounted() {
    this.getPermissions();
  },
  methods: {
    async getPermissions() {
      await this.getList(`/permission?take=1000`);
      this.all_data.data.forEach((item) => {
        this.permessionNames.push({
          value: item.id,
          text: item.name,
        });
      });
      this.loading = false;
    },

    addRole() {
      this.loading = true;
      if (!this.permissionForm.name) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "validation error",
            variant: "danger",
            text: "Name is required",
          },
        });
        this.loading = false;
        return;
      }
      (this.params.form = this.permissionForm),
        (this.params.path = "/role"),
        this.$store
          .dispatch("create", this.params)
          .then(() => {
            this.loading = false;
            this.$router.push("/operations/roles");
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Permission Created",
                icon: "success",
                variant: "info",
                text:
                  "Permission " +
                  this.permissionForm.name +
                  " Added Successfully",
              },
            });
          })
          .catch((error) => {
            this.loading = false;
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
    },
  },
};
</script>

<style scoped>
.modify_checkbox {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  align-items: center;
  row-gap: 30px;
  column-gap: 5px;
}

.custom-checkbox {
  width: 18rem;
  height: 3rem;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
